import React from "react";
import { withTranslation } from "react-i18next";
import { Image } from "hesus-ui-kit";
import { FlexRow, ButtonData } from "./TabsView.styled";
import warningIcon from "@icons/ic-warning.svg";
import "../../CenterProductView.scss";

const Tabs = (props) => {
  const { t, activeTab, toggleTab, pollutionTab, polllutions } = props;

  return (
    <FlexRow>
      <div>
        <ButtonData
          marginRight="10px"
          color={activeTab === "general" ? "#008395" : "#cccccc"}
          onClick={() => toggleTab("general")}
        >
          {t("GENERAL_INFORMATION")}
        </ButtonData>
      </div>
      <div>
        <ButtonData
          marginRight="10px"
          color={activeTab === "contact" ? "#008395" : "#cccccc"}
          onClick={() => toggleTab("contact")}
        >
          {t("CONTACTS")}
        </ButtonData>
      </div>
      {!!pollutionTab && (
        <div>
          <ButtonData
            marginRight="10px"
            color={activeTab === "pollution" ? "#008395" : "#cccccc"}
            onClick={() => toggleTab("pollution")}
          >
            {polllutions === null && (
              <Image
                src={warningIcon}
                className="center-products-view__image-icon-tab"
              />
            )}

            {t("POLLUTION")}
          </ButtonData>
        </div>
      )}
    </FlexRow>
  );
};

export default withTranslation()(Tabs);
